import "./style.css";
import { mountListView } from "./views/list-view";
import { mountViewerView } from "./views/viewer";

const root = document.getElementById("app");
if (!root) throw new Error("#app não encontrado no index.html");

let dispose: (() => void) | null = null;

function parseRoute(): { name: "list" } | { name: "view"; id: string } {
  const hash = location.hash.slice(1); // remove "#"
  if (hash.startsWith("/view/")) {
    const id = hash.slice("/view/".length);
    if (id) return { name: "view", id };
  }
  return { name: "list" };
}

function render(): void {
  if (dispose) {
    dispose();
    dispose = null;
  }
  const route = parseRoute();
  root!.className = `route-${route.name}`;
  if (route.name === "list") {
    dispose = mountListView(root!);
  } else {
    dispose = mountViewerView(root!, route.id);
  }
}

window.addEventListener("hashchange", render);
render();
